import { render, staticRenderFns } from "./solution-specs.vue?vue&type=template&id=3023693f&scoped=true"
import script from "./solution-specs.vue?vue&type=script&lang=js"
export * from "./solution-specs.vue?vue&type=script&lang=js"
import style0 from "./solution-specs.vue?vue&type=style&index=0&id=3023693f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023693f",
  null
  
)

export default component.exports